module.exports = __webpack_public_path__ + "static/media/katrina.70253a80.svg";